//  const baseURL = "http://localhost:5046/api";
//  const baseURL="https://girvibackend.prakash-n-co.in/api";
const baseURL="https://girvibackend.grjewellers.in/api";
// const baseURL="https://sashigirvibackend.riddhi-infotech.com/api";


export default baseURL;